import { Component } from 'react';

import styles from './feature-details.component.module.scss';

interface FeatureDetailsComponentProps {
    markdown: string;
}

export class FeatureDetailsComponent extends Component<FeatureDetailsComponentProps> {
    constructor(props) {
        super(props);
    }

    render() {
        if (this.props.markdown) {
            const sections = this.props.markdown.split('<h4').filter(str => str.length > 0).map(str => `<h4 ${str}`);
            if (sections.length > 0) {
                return <div className="row">
                    {
                        sections.map((html, index) => {
                            return <div key={`feature-detail-${index}`} className="col-12 col-sm-12 col-md-12 col-lg-12 mt-3">
                                <div className={`section text-left ${styles['feature-details']}`}
                                    dangerouslySetInnerHTML={{ __html: html }}>
                                </div>
                            </div>
                        })
                    }
                </div>
            }
        }
        return <div className={`${this.props.markdown ? 'section' : ''} text-left ${styles['feature-details']}`}
            dangerouslySetInnerHTML={{ __html: this.props.markdown }}>
        </div>
    }
}